import { JSONAPIDocument } from "json-api-serializer";
import { API_URL, questionsLoader } from "./QuestionsLoader";
import { QuestionQuery } from "./typings";
import { stringifyUrl } from "query-string";

const include = [
	"skills",
	"topics",
	"tex_helpers",
	"parent_question",
	"children_questions",
	"children_questions.tex_helpers",
	"children_questions.skills",
	"children_questions.topics",
];

export class QuestionsApi {
	public static importQuestions(data: JSONAPIDocument) {
		return questionsLoader.post({
			baseURL: API_URL,
			url: "/questions/import",
			data: data,
		});
	}

	public static exportQuestions() {
		return questionsLoader.get({
			baseURL: API_URL,
			url: "/questions/export",
			responseType: "blob",
		});
	}

	public static getQuestions(query: QuestionQuery = {}): Promise<JSONAPIDocument> {
		const url = stringifyUrl(
			{ url: "/questions", query: { ...query, include: include.toString() } },
			{ arrayFormat: "index" }
		);
		return questionsLoader.get({
			baseURL: API_URL,
			url,
		});
	}

	public static getQuestion(id: string) {
		const url = stringifyUrl({ url: `/questions/${id}`, query: { include } }, { arrayFormat: "comma" });
		return questionsLoader.get({
			baseURL: API_URL,
			url,
		});
	}

	public static createQuestion(data: JSONAPIDocument) {
		const url = stringifyUrl({ url: `/questions`, query: { include } }, { arrayFormat: "comma" });
		return questionsLoader.post({
			baseURL: API_URL,
			url,
			data,
		});
	}

	public static updateQuestion(id: string, data: JSONAPIDocument) {
		const url = stringifyUrl({ url: `/questions/${id}`, query: { include } }, { arrayFormat: "comma" });
		return questionsLoader.patch({
			baseURL: API_URL,
			url,
			data,
		});
	}

	public static deleteQuestion(id: string, data: JSONAPIDocument) {
		const url = stringifyUrl({ url: `/questions/${id}` }, { arrayFormat: "comma" });
		return questionsLoader.delete({
			baseURL: API_URL,
			url,
		})
	}
}
